import { useLocation } from "react-router-dom";
import { useSessionInactivity } from "../hooks/useSessionInactivity";
import { getCleanPath } from "../utils/publicPaths";
import { isSessionAcknowledged } from "../utils/sessionGate";

function SessionInactivityWatcher() {
  const location = useLocation();
  const cleanPath = getCleanPath(location.pathname);
  const enabled = isSessionAcknowledged() && cleanPath !== "/login";
  useSessionInactivity(enabled);
  return null;
}

export default SessionInactivityWatcher;
